export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M18.112,14.444a4.036,4.036,0,0,0-3.673,2.365,3.7,3.7,0,0,0-1.878,0,4.04,4.04,0,0,0-7.717,1.679.25.25,0,0,0,.25.25H10a4,4,0,0,0-.547,1.993.25.25,0,0,0,.25.25h7.588a.25.25,0,0,0,.25-.25A4,4,0,0,0,17,18.738h4.909a.25.25,0,0,0,.25-.25A4.049,4.049,0,0,0,18.112,14.444ZM5.353,18.238a3.539,3.539,0,0,1,6.724-1.279,4.038,4.038,0,0,0-1.736,1.279Zm4.612,2.243a3.544,3.544,0,0,1,7.07,0Zm6.694-2.243a4.038,4.038,0,0,0-1.736-1.279,3.539,3.539,0,0,1,6.724,1.279Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,11.353a2.334,2.334,0,1,0,2.334,2.335A2.337,2.337,0,0,0,13.5,11.353Zm0,4.168a1.834,1.834,0,1,1,1.834-1.833A1.835,1.835,0,0,1,13.5,15.521Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,6.019a2.335,2.335,0,1,0,2.334,2.334A2.336,2.336,0,0,0,13.5,6.019Zm0,4.169a1.835,1.835,0,1,1,1.834-1.835A1.837,1.837,0,0,1,13.5,10.188Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M18.112,13.778a2.335,2.335,0,1,0-2.334-2.335A2.337,2.337,0,0,0,18.112,13.778Zm0-4.169a1.835,1.835,0,1,1-1.834,1.834A1.836,1.836,0,0,1,18.112,9.609Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M8.888,9.109a2.335,2.335,0,1,0,2.334,2.334A2.337,2.337,0,0,0,8.888,9.109Zm0,4.169a1.835,1.835,0,1,1,1.834-1.835A1.836,1.836,0,0,1,8.888,13.278Z"
		/>
	</svg>
)
